import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';

interface Props {
  open: boolean;
  loading: boolean;

  handleClose(): void;
  handleStopRunningCampaignAndProceed(): void;
}

const StopRunningCampaignDialog: React.FC<Props> = ({ open, loading, handleClose, handleStopRunningCampaignAndProceed }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('stopRunningCampaignDialogTitle')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Stack gap={1}>
          <Typography className={classes.text}>{t('stopRunningCampaignDialogContent1')}</Typography>
          <Typography className={cx(classes.text, 'highlight')}>{t('stopRunningCampaignDialogContent2')}</Typography>
          <Typography className={classes.text} sx={{ textDecoration: 'underline' }}>
            {t('stopRunningCampaignDialogContent3')}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('stopAndEditCampaign')} size={'small'} border={'rounded'} action={handleStopRunningCampaignAndProceed} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  title: {
    background: 'linear-gradient(to right, #5044FF, #4AA4FF)',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
    '&.highlight': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
  warningText: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

export default StopRunningCampaignDialog;
